<template>
  <div class="list-box">
    <ul class="list-search">
      <el-space wrap style="flex: 1">
        <el-input
          v-model="state.params.name"
          style="width: 200px"
          placeholder="--关键字--"
          clearable
          @clear="
            delete state.params.name;
            onLoad();
          "
        ></el-input>
        <el-date-picker
          v-model="state.dates"
          type="daterange"
          range-separator="至"
          start-placeholder="--到账日期--"
          end-placeholder="--到账日期--"
          style="width: 400px"
          value-format="YYYY-MM-DD"
          @change="
            (value) => {
              if (value)
                state.params.received_date = value[0] + ' - ' + value[1];
            }
          "
          @clear="
            delete state.dates;
            delete state.params.received_date;
          "
        />
        <el-dropdown split-button @click="onLoad" type="primary">
          查询
          <template #dropdown>
            <el-dropdown-menu>
              <el-dropdown-item :icon="RefreshLeft" @click="onReset()">
                重置
              </el-dropdown-item>
            </el-dropdown-menu>
          </template>
        </el-dropdown>
      </el-space>
    </ul>
    <ul class="list-table">
      <el-table
        :data="state.tableData"
        v-loading="!Array.isArray(state.tableData)"
        element-loading-background="rgba(0, 0, 0, 0.2)"
        :default-sort="{
          prop: state.params.sort_field,
          order: state.params.sort_value == 'desc' ? 'descending' : 'ascending',
        }"
        @sort-change="onSortChange"
      >
        <el-table-column
          fixed
          label="序号"
          width="70"
          type="index"
          :index="
            (index) => (state.params.page - 1) * state.params.limit + index + 1
          "
          align="center"
        />
        <el-table-column
          label="状态/ID"
          sortable="collected_status"
          width="120"
        >
          <template #default="{ row }">
            <div
              style="display: flex; flex-direction: column; width: fit-content"
            >
              <component
                :is="
                  $statusFormat2(
                    'bankReceived_collected_status',
                    row.collected_status
                  )
                "
              />
              <text
                style="
                  color: #a2a2a2;
                  font-size: var(--tab-group-second-font-size);
                  text-align: center;
                "
              >
                {{ row.id }}
              </text>
            </div>
          </template>
        </el-table-column>
        <el-table-column
          label="到账银行"
          :formatter="
            (row) =>
              $tab_GroupFormat(
                row.bank_account?.account,
                row.bank_account?.opening_bank || ''
              )
          "
          min-width="220"
        />
        <el-table-column
          label="付款银行"
          :formatter="
            (row) =>
              $tab_GroupFormat(
                row.payment_account,
                row.payment_opening_bank || ''
              )
          "
          min-width="220"
        />

        <el-table-column label="摘要信息/认领明细" min-width="400">
          <template #default="{ row }">
            <div>
              <ul>
                {{
                  row.customer_name
                }}
              </ul>
              <ul
                v-if="row.collected_amount_detail?.collected"
                style="
                  color: #a2a2a2;
                  font-size: var(--tab-group-second-font-size);
                "
                v-html="
                  Object.keys(row.collected_amount_detail?.collected)
                    .map(
                      (key) =>
                        `${key}: <text style='color:#ffa500;margin-right:5px'>${$priceFormat(
                          row.collected_amount_detail?.collected[key]
                        )}</text>`
                    )
                    .join(' ')
                "
              ></ul>
            </div>
          </template>
        </el-table-column>
        <el-table-column
          label="金额/到账时间"
          align="right"
          :formatter="
            (row) =>
              $tab_GroupFormat(
                $priceFormat(row.received_amount),
                row.received_date || ''
              )
          "
          min-width="200"
        />
        <el-table-column
          label="实际到账金额/手续费"
          align="right"
          :formatter="
            (row) =>
              $tab_GroupFormat(
                $priceFormat(row.real_received_amount),
                $priceFormat(row.service_fee)
              )
          "
          min-width="200"
        />
        <el-table-column
          label="已认领/未认领金额"
          align="right"
          :formatter="
            (row) =>
              $tab_GroupFormat(
                $priceFormat(row.collected_amount),
                $priceFormat(row.uncollected_amount)
              )
          "
          min-width="200"
        />
        <el-table-column
          label="操作"
          width="120"
          align="center"
          fixed="right"
          className="tabBtn"
          v-if="$judge_auth('47')"
        >
          <template #default="{ row }">
            <el-button
              type="primary"
              link
              icon="Edit"
              @click="
                $store.commit('openMenu', {
                  path: 'BankReceivedDetail',
                  title: '银行到账操作',
                  refresh: true,
                  data: {
                    id: row.id,
                  },
                })
              "
            >
              操作
            </el-button>
          </template>
        </el-table-column>
      </el-table>
      <c_page
        :total="state.totalCount"
        :pageIndex="state.params.page"
        :pageSize="state.params.limit"
        @onLoad="
          (page) => {
            state.params.page = page.pageIndex;
            state.params.limit = page.pageSize;
            onLoad();
          }
        "
      />
    </ul>
  </div>
  <transition name="el-zoom-in-center">
    <c_popup
      v-if="state.showInfo"
      :title="(state.selectId ? '修改' : '添加') + '到账公示'"
      @close="state.showInfo = false"
    >
      <c_BankReceivedInfo
        @close="
          state.showInfo = false;
          onLoad();
        "
        :id="state.selectId"
      ></c_BankReceivedInfo>
    </c_popup>
  </transition>
</template>

<script>
import { onMounted, reactive } from "vue";
import { customermine_bankreceived_list } from "@/http/customer";

class InitFormData {
  params = {
    limit: 20,
    page: 1,
    sort_field: "create_time",
    sort_value: "desc",
    name: "",
  };
}
export default {
  props: {
    customer_id: Number,
  },
  setup(props) {
    const state = reactive(new InitFormData());
    onMounted(() => {
      state.params.customer_id = props.customer_id;
      onLoad();
    });

    const onLoad = () => {
      delete state.tableData;

      customermine_bankreceived_list(state.params).then((res) => {
        if (res.status == 200) {
          const { count, list } = res.data.data;
          state.tableData = list;
          state.totalCount = count;
        }
      });
    };

    //排序
    const onSortChange = ({ column }) => {
      if (column.order) {
        state.params.sort_field = column.sortable;
        state.params.sort_value = column.order === "ascending" ? "asc" : "desc";
      } else {
        const params = new InitFormData().params;
        state.params.sort_field = params.Order;
        state.params.sort_value = "asc";
      }
      onLoad();
    };

    //重置查询条件
    const onReset = () => {
      Object.assign(state, new InitFormData());
      onLoad();
    };

    return {
      state,
      onLoad,
      onSortChange,
      onReset,
    };
  },
};
</script>
<style lang="less">
.bank-received-index-tab-pop {
  .el-descriptions__header {
    margin-bottom: 0 !important;
  }
}
</style>
